import { useSeoMeta } from '@unhead/react';
import { useParams } from 'react-router-dom';
import JobBoardSection from '@/components/JobBoard';

const mineralMeta: Record<string, { title: string; kw: string }> = {
  gold: { title: 'Gold Mining Jobs Australia | MineralJobs', kw: 'gold mining jobs Australia' },
  coal: { title: 'Coal Mining Jobs Australia | MineralJobs', kw: 'coal mining jobs Australia' },
  copper: { title: 'Copper Mining Jobs Australia | MineralJobs', kw: 'copper mine jobs WA' },
  'iron-ore': { title: 'Iron Ore Mining Jobs Australia | MineralJobs', kw: 'iron ore jobs Pilbara' },
};

export default function MineralJobsPage() {
  const { mineral = 'gold' } = useParams<{ mineral: string }>();
  const meta = mineralMeta[mineral] ?? mineralMeta['gold'];

  useSeoMeta({
    title: meta.title,
    description: `Browse ${mineral.replace('-', ' ')} mining jobs in Australia. FIFO and residential roles for all experience levels. Apply on MineralJobs today.`,
    ogTitle: meta.title,
    ogUrl: `https://www.mineraljobs.com/jobs/${mineral}/`,
    twitterCard: 'summary_large_image',
  });

  const displayName = mineral
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

  return (
    <main>
      <div className="min-h-screen pt-16" style={{ background: '#111827' }}>
        <div className="max-w-3xl mx-auto px-4 py-12 text-center">
          <h1 className="text-5xl font-black text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            <span style={{ color: '#f97316' }}>{displayName}</span> Mining Jobs Australia
          </h1>
          <p className="text-gray-400 text-lg">
            Browse {displayName} mining jobs in Australia. FIFO and residential roles for all experience levels.
          </p>
        </div>
        <JobBoardSection />
      </div>
    </main>
  );
}
